import L from "./extends3.mjs";
import { getMonthsInYear as W } from "./date-utils.mjs";
const P = (e, a) => {
  const t = e.formatTokenMap[a];
  if (t == null)
    throw new Error([`MUI: The token "${a}" is not supported by the Date and Time Pickers.`, "Please try using another token or open an issue on https://github.com/mui/mui-x/issues/new/choose if you think it should be supported."].join(`
`));
  return typeof t == "string" ? {
    type: t,
    contentType: t === "meridiem" ? "letter" : "digit",
    maxLength: void 0
  } : {
    type: t.sectionType,
    contentType: t.contentType,
    maxLength: t.maxLength
  };
}, H = (e) => {
  switch (e) {
    case "ArrowUp":
      return 1;
    case "ArrowDown":
      return -1;
    case "PageUp":
      return 5;
    case "PageDown":
      return -5;
    default:
      return 0;
  }
}, k = (e, a, t) => {
  const r = [], n = e.dateWithTimezone(void 0, a), i = e.startOfWeek(n), s = e.endOfWeek(n);
  let o = i;
  for (; e.isBefore(o, s); )
    r.push(o), o = e.addDays(o, 1);
  return r.map((d) => e.formatByString(d, t));
}, Z = (e, a, t, r) => {
  switch (t) {
    case "month":
      return W(e, e.dateWithTimezone(void 0, a)).map((n) => e.formatByString(n, r));
    case "weekDay":
      return k(e, a, r);
    case "meridiem": {
      const n = e.dateWithTimezone(void 0, a);
      return [e.startOfDay(n), e.endOfDay(n)].map((i) => e.formatByString(i, r));
    }
    default:
      return [];
  }
}, b = (e, a, t) => {
  let r = a;
  for (r = Number(r).toString(); r.length < t; )
    r = `0${r}`;
  return r;
}, j = (e, a, t, r, n) => {
  if (process.env.NODE_ENV !== "production" && n.type !== "day" && n.contentType === "digit-with-letter")
    throw new Error([`MUI: The token "${n.format}" is a digit format with letter in it.'
             This type of format is only supported for 'day' sections`].join(`
`));
  if (n.type === "day" && n.contentType === "digit-with-letter") {
    const s = e.setDate(r.longestMonth, t);
    return e.formatByString(s, n.format);
  }
  const i = t.toString();
  return n.hasLeadingZerosInInput ? b(e, i, n.maxLength) : i;
}, R = (e, a, t, r, n, i, s) => {
  const o = H(r), d = r === "Home", c = r === "End", p = t.value === "" || d || c, y = () => {
    const m = n[t.type]({
      currentDate: i,
      format: t.format,
      contentType: t.contentType
    }), w = (D) => j(e, a, D, m, t), g = t.type === "minutes" && s != null && s.minutesStep ? s.minutesStep : 1;
    let f = parseInt(t.value, 10) + o * g;
    if (p) {
      if (t.type === "year" && !c && !d)
        return e.formatByString(e.dateWithTimezone(void 0, a), t.format);
      o > 0 || d ? f = m.minimum : f = m.maximum;
    }
    return f % g !== 0 && ((o < 0 || d) && (f += g - (g + f) % g), (o > 0 || c) && (f -= f % g)), f > m.maximum ? w(m.minimum + (f - m.maximum - 1) % (m.maximum - m.minimum + 1)) : f < m.minimum ? w(m.maximum - (m.minimum - f - 1) % (m.maximum - m.minimum + 1)) : w(f);
  }, I = () => {
    const m = Z(e, a, t.type, t.format);
    if (m.length === 0)
      return t.value;
    if (p)
      return o > 0 || d ? m[0] : m[m.length - 1];
    const g = (m.indexOf(t.value) + m.length + o) % m.length;
    return m[g];
  };
  return t.contentType === "digit" || t.contentType === "digit-with-letter" ? y() : I();
}, E = (e, a) => {
  let t = e.value || e.placeholder;
  const r = a === "non-input" ? e.hasLeadingZerosInFormat : e.hasLeadingZerosInInput;
  return a === "non-input" && e.hasLeadingZerosInInput && !e.hasLeadingZerosInFormat && (t = Number(t).toString()), ["input-rtl", "input-ltr"].includes(a) && e.contentType === "digit" && !r && t.length === 1 && (t = `${t}‎`), a === "input-rtl" && (t = `⁨${t}⁩`), t;
}, B = (e) => e.replace(/[\u2066\u2067\u2068\u2069]/g, ""), z = (e, a) => {
  let t = 0, r = a ? 1 : 0;
  const n = [];
  for (let i = 0; i < e.length; i += 1) {
    const s = e[i], o = E(s, a ? "input-rtl" : "input-ltr"), d = `${s.startSeparator}${o}${s.endSeparator}`, c = B(d).length, p = d.length, y = B(o), I = r + o.indexOf(y[0]) + s.startSeparator.length, m = I + y.length;
    n.push(L({}, s, {
      start: t,
      end: t + c,
      startInInput: I,
      endInInput: m
    })), t += c, r += p;
  }
  return n;
}, A = (e, a, t, r, n) => {
  switch (r.type) {
    case "year":
      return t.fieldYearPlaceholder({
        digitAmount: e.formatByString(e.dateWithTimezone(void 0, a), n).length,
        format: n
      });
    case "month":
      return t.fieldMonthPlaceholder({
        contentType: r.contentType,
        format: n
      });
    case "day":
      return t.fieldDayPlaceholder({
        format: n
      });
    case "weekDay":
      return t.fieldWeekDayPlaceholder({
        contentType: r.contentType,
        format: n
      });
    case "hours":
      return t.fieldHoursPlaceholder({
        format: n
      });
    case "minutes":
      return t.fieldMinutesPlaceholder({
        format: n
      });
    case "seconds":
      return t.fieldSecondsPlaceholder({
        format: n
      });
    case "meridiem":
      return t.fieldMeridiemPlaceholder({
        format: n
      });
    default:
      return n;
  }
}, K = (e, a, t, r) => {
  if (process.env.NODE_ENV !== "production" && P(e, t).type === "weekDay")
    throw new Error("changeSectionValueFormat doesn't support week day formats");
  return e.formatByString(e.parse(a, t), r);
}, N = (e, a, t) => e.formatByString(e.dateWithTimezone(void 0, a), t).length === 4, Y = (e, a, t, r, n) => {
  if (t !== "digit")
    return !1;
  const i = e.dateWithTimezone(void 0, a);
  switch (r) {
    case "year":
      return N(e, a, n) ? e.formatByString(e.setYear(i, 1), n) === "0001" : e.formatByString(e.setYear(i, 2001), n) === "01";
    case "month":
      return e.formatByString(e.startOfYear(i), n).length > 1;
    case "day":
      return e.formatByString(e.startOfMonth(i), n).length > 1;
    case "weekDay":
      return e.formatByString(e.startOfWeek(i), n).length > 1;
    case "hours":
      return e.formatByString(e.setHours(i, 1), n).length > 1;
    case "minutes":
      return e.formatByString(e.setMinutes(i, 1), n).length > 1;
    case "seconds":
      return e.formatByString(e.setSeconds(i, 1), n).length > 1;
    default:
      throw new Error("Invalid section type");
  }
}, C = (e, a) => {
  const t = [], {
    start: r,
    end: n
  } = e.escapedCharacters, i = new RegExp(`(\\${r}[^\\${n}]*\\${n})+`, "g");
  let s = null;
  for (; s = i.exec(a); )
    t.push({
      start: s.index,
      end: i.lastIndex - 1
    });
  return t;
}, q = (e, a, t, r, n, i, s, o) => {
  let d = "";
  const c = [], p = e.date(), y = (u) => {
    if (u === "")
      return null;
    const h = P(e, u), S = Y(e, a, h.contentType, h.type, u), l = s ? S : h.contentType === "digit", O = n != null && e.isValid(n);
    let M = O ? e.formatByString(n, u) : "", x = null;
    if (l)
      if (S)
        x = M === "" ? e.formatByString(p, u).length : M.length;
      else {
        if (h.maxLength == null)
          throw new Error(`MUI: The token ${u} should have a 'maxDigitNumber' property on it's adapter`);
        x = h.maxLength, O && (M = b(e, M, x));
      }
    return c.push(L({}, h, {
      format: u,
      maxLength: x,
      value: M,
      placeholder: A(e, a, t, h, u),
      hasLeadingZeros: S,
      hasLeadingZerosInFormat: S,
      hasLeadingZerosInInput: l,
      startSeparator: c.length === 0 ? d : "",
      endSeparator: "",
      modified: !1
    })), null;
  };
  let I = 10, m = r, w = e.expandFormat(r);
  for (; w !== m; )
    if (m = w, w = e.expandFormat(m), I -= 1, I < 0)
      throw new Error("MUI: The format expansion seems to be  enter in an infinite loop. Please open an issue with the format passed to the picker component");
  const g = w, v = C(e, g), f = new RegExp(`^(${Object.keys(e.formatTokenMap).sort((u, h) => h.length - u.length).join("|")})`, "g");
  let D = "";
  for (let u = 0; u < g.length; u += 1) {
    const h = v.find((x) => x.start <= u && x.end >= u), S = g[u], l = h != null, O = `${D}${g.slice(u)}`, M = f.test(O);
    !l && S.match(/([A-Za-z]+)/) && M ? (D = O.slice(0, f.lastIndex), u += f.lastIndex - 1) : l && h?.start === u || h?.end === u || (y(D), D = "", c.length === 0 ? d += S : c[c.length - 1].endSeparator += S);
  }
  return y(D), c.map((u) => {
    const h = (S) => {
      let l = S;
      return o && l !== null && l.includes(" ") && (l = `⁩${l}⁦`), i === "spacious" && ["/", ".", "-"].includes(l) && (l = ` ${l} `), l;
    };
    return u.startSeparator = h(u.startSeparator), u.endSeparator = h(u.endSeparator), u;
  });
}, G = (e, a) => {
  const t = a.some((o) => o.type === "day"), r = [], n = [];
  for (let o = 0; o < a.length; o += 1) {
    const d = a[o];
    t && d.type === "weekDay" || (r.push(d.format), n.push(E(d, "non-input")));
  }
  const i = r.join(" "), s = n.join(" ");
  return e.parse(s, i);
}, J = (e, a) => {
  const r = e.map((n) => {
    const i = E(n, a ? "input-rtl" : "input-ltr");
    return `${n.startSeparator}${i}${n.endSeparator}`;
  }).join("");
  return a ? `⁦${r}⁩` : r;
}, Q = (e, a) => {
  const t = e.dateWithTimezone(void 0, a), r = e.endOfYear(t), n = e.endOfDay(t), {
    maxDaysInMonth: i,
    longestMonth: s
  } = W(e, t).reduce((o, d) => {
    const c = e.getDaysInMonth(d);
    return c > o.maxDaysInMonth ? {
      maxDaysInMonth: c,
      longestMonth: d
    } : o;
  }, {
    maxDaysInMonth: 0,
    longestMonth: null
  });
  return {
    year: ({
      format: o
    }) => ({
      minimum: 0,
      maximum: N(e, a, o) ? 9999 : 99
    }),
    month: () => ({
      minimum: 1,
      // Assumption: All years have the same amount of months
      maximum: e.getMonth(r) + 1
    }),
    day: ({
      currentDate: o
    }) => ({
      minimum: 1,
      maximum: o != null && e.isValid(o) ? e.getDaysInMonth(o) : i,
      longestMonth: s
    }),
    weekDay: ({
      format: o,
      contentType: d
    }) => {
      if (d === "digit") {
        const c = k(e, a, o).map(Number);
        return {
          minimum: Math.min(...c),
          maximum: Math.max(...c)
        };
      }
      return {
        minimum: 1,
        maximum: 7
      };
    },
    hours: ({
      format: o
    }) => {
      const d = e.getHours(n);
      return e.formatByString(e.endOfDay(t), o) !== d.toString() ? {
        minimum: 1,
        maximum: Number(e.formatByString(e.startOfDay(t), o))
      } : {
        minimum: 0,
        maximum: d
      };
    },
    minutes: () => ({
      minimum: 0,
      // Assumption: All years have the same amount of minutes
      maximum: e.getMinutes(n)
    }),
    seconds: () => ({
      minimum: 0,
      // Assumption: All years have the same amount of seconds
      maximum: e.getSeconds(n)
    }),
    meridiem: () => ({
      minimum: 0,
      maximum: 0
    })
  };
};
let V = !1;
const X = (e, a) => {
  if (process.env.NODE_ENV !== "production" && !V) {
    const t = [];
    ["date", "date-time"].includes(a) && t.push("weekDay", "day", "month", "year"), ["time", "date-time"].includes(a) && t.push("hours", "minutes", "seconds", "meridiem");
    const r = e.find((n) => !t.includes(n.type));
    r && (console.warn(`MUI: The field component you are using is not compatible with the "${r.type} date section.`, `The supported date sections are ["${t.join('", "')}"]\`.`), V = !0);
  }
}, U = (e, a, t, r, n) => {
  switch (t.type) {
    case "year":
      return e.setYear(n, e.getYear(r));
    case "month":
      return e.setMonth(n, e.getMonth(r));
    case "weekDay": {
      const i = k(e, a, t.format), s = e.formatByString(r, t.format), o = i.indexOf(s), c = i.indexOf(t.value) - o;
      return e.addDays(r, c);
    }
    case "day":
      return e.setDate(n, e.getDate(r));
    case "meridiem": {
      const i = e.getHours(r) < 12, s = e.getHours(n);
      return i && s >= 12 ? e.addHours(n, -12) : !i && s < 12 ? e.addHours(n, 12) : n;
    }
    case "hours":
      return e.setHours(n, e.getHours(r));
    case "minutes":
      return e.setMinutes(n, e.getMinutes(r));
    case "seconds":
      return e.setSeconds(n, e.getSeconds(r));
    default:
      return n;
  }
}, $ = {
  year: 1,
  month: 2,
  day: 3,
  weekDay: 4,
  hours: 5,
  minutes: 6,
  seconds: 7,
  meridiem: 8
}, T = (e, a, t, r, n, i) => (
  // cloning sections before sort to avoid mutating it
  [...r].sort((s, o) => $[s.type] - $[o.type]).reduce((s, o) => !i || o.modified ? U(e, a, o, t, s) : s, n)
), ee = () => navigator.userAgent.toLowerCase().indexOf("android") > -1, te = (e, a) => {
  const t = {};
  if (!a)
    return e.forEach((d, c) => {
      const p = c === 0 ? null : c - 1, y = c === e.length - 1 ? null : c + 1;
      t[c] = {
        leftIndex: p,
        rightIndex: y
      };
    }), {
      neighbors: t,
      startIndex: 0,
      endIndex: e.length - 1
    };
  const r = {}, n = {};
  let i = 0, s = 0, o = e.length - 1;
  for (; o >= 0; ) {
    s = e.findIndex(
      // eslint-disable-next-line @typescript-eslint/no-loop-func
      (d, c) => {
        var p;
        return c >= i && ((p = d.endSeparator) == null ? void 0 : p.includes(" ")) && // Special case where the spaces were not there in the initial input
        d.endSeparator !== " / ";
      }
    ), s === -1 && (s = e.length - 1);
    for (let d = s; d >= i; d -= 1)
      n[d] = o, r[o] = d, o -= 1;
    i = s + 1;
  }
  return e.forEach((d, c) => {
    const p = n[c], y = p === 0 ? null : r[p - 1], I = p === e.length - 1 ? null : r[p + 1];
    t[c] = {
      leftIndex: y,
      rightIndex: I
    };
  }), {
    neighbors: t,
    startIndex: r[0],
    endIndex: r[e.length - 1]
  };
};
export {
  z as addPositionPropertiesToSections,
  R as adjustSectionValue,
  K as changeSectionValueFormat,
  j as cleanDigitSectionValue,
  b as cleanLeadingZeros,
  B as cleanString,
  J as createDateStrForInputFromSections,
  Y as doesSectionFormatHaveLeadingZeros,
  G as getDateFromDateSections,
  P as getDateSectionConfigFromFormatToken,
  k as getDaysInWeekStr,
  Z as getLetterEditingOptions,
  te as getSectionOrder,
  E as getSectionVisibleValue,
  Q as getSectionsBoundaries,
  ee as isAndroid,
  T as mergeDateIntoReferenceDate,
  q as splitFormatIntoSections,
  X as validateSections
};
//# sourceMappingURL=useField.utils.mjs.map
